import { type MouseEvent, useCallback } from 'react';
import { useBetslipContext } from '@cx-web/feature-betslip/context';

import { type Bet } from '~/apps/product-plus/components/BettingInsights/types';

export const useNonOCRepubBetslip = ({
  bet,
  bookieName,
  onClick,
}: {
  bet: Bet;
  bookieName: string;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
}) => {
  const { addOrRemoveFromBetslip, betslip } = useBetslipContext();

  const isBetInBetslip = !!betslip.find(({ betId }) => betId == bet.betId);

  const handleClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      addOrRemoveFromBetslip([{ betId: bet.betId }], [bet.betId], bookieName);
      onClick?.(e);
    },
    [onClick, bet, addOrRemoveFromBetslip, bookieName],
  );

  return { isBetInBetslip, handleClick };
};
